import { Button, Icon } from "@mui/material";
import { useTranslation } from "react-i18next";

import fernieButtonSx from "~/components/fernie/fernieButtonSx";
import { TOUR_ANCHORS } from "~/walkthroughs/registry";

interface FernieRequestsToggleProps {
	active: boolean;
	onClick: () => void;
}

const FernieRequestsToggle = ({ active, onClick }: FernieRequestsToggleProps) => {
	const { t } = useTranslation("common");
	return (
		<Button
			aria-pressed={active}
			data-tour-id={TOUR_ANCHORS.fernieRequestsToggle}
			onClick={onClick}
			size="small"
			startIcon={<Icon sx={{ fontSize: 18 }}>inbox</Icon>}
			sx={{
				...fernieButtonSx.focusRing,
				backgroundColor: active ? "action.selected" : "transparent",
				borderRadius: "10px",
				color: active ? "text.primary" : "text.secondary",
				fontSize: 12,
				minWidth: 0,
				px: 1,
				textTransform: "none"
			}}
		>
			{t("fernieChat.requests.title")}
		</Button>
	);
};

export default FernieRequestsToggle;
